import { observer } from 'mobx-react-lite';
import Box from '../../uikit/Box';
import Frame from '../../uikit/Frame';
import MetaHeader from '../../views/MetaHeader';
import DocViewer from '../../views/common/DocViewer';

const TYPE_DOC_MAP = {
    terms: {
        docKey: 'listening-terms',
        title: '이용약관',
    },
    privacy: {
        docKey: 'listening-privacy',
        title: '개인정보처리방침',
    },
    license: {
        docKey: 'open-source-license',
        title: '오픈소스 라이선스',
    },
};

const ListeningTermsPage = observer(({ type }: { type: keyof typeof TYPE_DOC_MAP }) => {
    const { docKey, title } = TYPE_DOC_MAP[type];

    return (
        <Frame className="bg-base-100">
            <MetaHeader title={title} />
            <Frame.Title title={title} />
            <Box>
                <DocViewer docKey={docKey} />
            </Box>
        </Frame>
    );
});

export default ListeningTermsPage;
